import { cn, SparkleIcon } from "@stacklet/ui";

/** Props for the Jun0Icon component */
interface Props {
  /** Additional classes forwarded to the underlying icon */
  className?: string;
}

/**
 * Sparkle icon pinned to the brand orange for the Jun0 AI nav item.
 *
 * The sparkle SVG fills with `currentColor`, so on its own it would inherit the
 * nav item's text color — gray (`text-text-secondary`) when inactive, brand
 * when active — and read as a plain gray icon most of the time. Forcing
 * `text-text-brand` keeps it orange regardless of nav state. (`text-text-brand`
 * resolves to the same orange in light and dark mode, so this is about state,
 * not theming.)
 */
export function Jun0Icon({ className }: Props) {
  return <SparkleIcon className={cn(className, "text-text-brand")} />;
}
